import {override} from 'mobx';
import {AutoAnimation} from "../../../../../infrastructure/models/animation/auto-animation";
import {YellowCardAnimationSetModel} from "../../../../../infrastructure/models/animation/game/animation-set-models/goal/yellow-card-animation-set-model";
import {ANIMATION_TIMES} from "../../../../../core/consts";
import styles from "../styles/game-center-header-animation.module.scss";
import classNames from "classnames"

export class GameCenterHeaderYellowCardAnimationSetModel extends YellowCardAnimationSetModel {
  duration: Number;

  constructor(animation) {
    super(animation);

    this.duration = ANIMATION_TIMES.GAME_CENTER.generalAnimationTime;
  }

  @override get statusText(): AutoAnimation {
    const enterAnimation: String = classNames('scale-up-center-infinite');
    const mainAnimation: String = classNames('visible');
    const leaveAnimation: String = classNames('scale-up-center-infinite');

    const statusText = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      0, this.durationByRatio(0.95), this.durationByRatio(0.05));

    return statusText;
  }

  @override get homeCompetitorLogo(): AutoAnimation {
    const enterAnimation: String = classNames('scale-up-center-disappear');
    const mainAnimation: String = classNames('hide');
    const leaveAnimation: String = classNames('scale-up-center-appear');

    const homeCompetitorLogo = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      0, this.durationByRatio(0.95), this.durationByRatio(0.05));

    return homeCompetitorLogo;
  }

  @override get homeCompetitorEventLogo(): AutoAnimation {
    const enterAnimation: String = classNames('scale-up-center-appear', styles.logo_home);
    const mainAnimation: String = classNames('visible', 'game-center-header-card-animation-logo-home');
    const leaveAnimation: String = classNames('scale-up-center-disappear', styles.logo_home);

    const homeCompetitorEventLogo = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      0, this.durationByRatio(0.95), this.durationByRatio(0.05));

    return homeCompetitorEventLogo;
  }

  @override get awayCompetitorLogo(): AutoAnimation {
    const enterAnimation: String = classNames('scale-up-center-disappear');
    const mainAnimation: String = classNames('hide');
    const leaveAnimation: String = classNames('scale-up-center-appear');

    const awayCompetitorLogo = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      0, this.durationByRatio(0.95), this.durationByRatio(0.05));

    return awayCompetitorLogo;
  }

  @override get awayCompetitorEventLogo(): AutoAnimation {
    const enterAnimation: String = classNames('scale-up-center-appear', 'game-center-header-animation-logo-away');
    const mainAnimation: String = classNames('visible', 'game-center-header-card-animation-logo-away');
    const leaveAnimation: String = classNames('scale-up-center-disappear', 'game-center-header-animation-logo-away');

    const awayCompetitorEventLogo = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      0, this.durationByRatio(0.95), this.durationByRatio(0.05));

    return awayCompetitorEventLogo;
  }
}
